
import Chart from "react-apexcharts";

interface ChartObject {
    options: string;
    series: string;
    type: string;
}

const DonutChart = ({ options, series, type }: any) => {

    return (
        <div>
            <Chart
                options={options}
                series={series}
                type={type}
                height={320}
            />
            {/* <div className="donut">
                <Chart options={dChartOption} series={dChartSeries} label={dChartLabels} type="donut" width="380" />
            </div> */}
        </div>
    )
}

export default DonutChart